import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { UserContext } from "../auth/UserProvider";
import { getResolverSegments, parsePathSegments } from "./Breadcrumbs";
import { useBreadcrumbData } from "./useBreadcrumbData";
var BASE_TITLE = "Log.Soccer";
/**
 * Sets document.title based on the current route's breadcrumb trail.
 *
 * For authenticated users: "Log.Soccer | <Last Breadcrumb Label>"
 * with resolved entity names (e.g. "Log.Soccer | My Team").
 *
 * For unauthenticated / home: just "Log.Soccer" or uses static
 * route config labels (e.g. "Log.Soccer | Login").
 */
export var usePageTitle = function () {
    var user = useContext(UserContext).user;
    var location = useLocation();
    var segments = parsePathSegments(location.pathname);
    var resolverSegments = getResolverSegments(segments);
    var resolvedNames = useBreadcrumbData(resolverSegments);
    useEffect(function () {
        if (location.pathname === "/") {
            document.title = BASE_TITLE;
            return;
        }
        var lastSegment = segments[segments.length - 1];
        if (!lastSegment) {
            document.title = BASE_TITLE;
            return;
        }
        var label = lastSegment.label;
        // Use resolved entity name if available
        if (lastSegment.resolver) {
            var resolved = resolvedNames[lastSegment.resolver];
            if (resolved) {
                label = resolved;
            }
        }
        // For unauthenticated users, still show static labels (Login, About Us, etc.)
        if (!user && label === "Home") {
            document.title = BASE_TITLE;
            return;
        }
        document.title = "".concat(BASE_TITLE, " | ").concat(label);
    }, [location.pathname, user, segments, resolvedNames]);
};
